import type { AutocompleteActionType } from 'redux/actions/autocompleteActions';
import {
  AUTOCOMPLETE_SEARCH_FAIL,
  AUTOCOMPLETE_SEARCH_START,
  AUTOCOMPLETE_SEARCH_SUCCESS,
} from 'redux/actions/types';
import type { AutocompleteState } from 'ts/types/autocomplete.types';

const initialState: AutocompleteState = {
  loading: false,
  results: [],
};

function autocompleteReducer(
  state = initialState,
  action: AutocompleteActionType,
) {
  switch (action.type) {
    case AUTOCOMPLETE_SEARCH_START:
      return { ...state, loading: true };
    case AUTOCOMPLETE_SEARCH_SUCCESS:
      return { ...state, loading: false, results: action.payload };
    case AUTOCOMPLETE_SEARCH_FAIL:
      return { ...state, loading: false };
    default:
      return state;
  }
}

export default autocompleteReducer;
